import { Injectable } from '@angular/core';
import { Funcionario } from '../api.service';
import { ModoCameraFacial } from './camera-facial.component';

@Injectable({ providedIn: 'root' })
export class ServicoFluxoFacial {
  mensagemAberturaCamera(modo: ModoCameraFacial) {
    if (modo === 'cadastro') {
      return 'Camera aberta. Centralize o rosto e pisque uma vez para cadastrar a face.';
    }
    if (modo === 'validacao') {
      return 'Camera aberta. Centralize o rosto e pisque uma vez para validar a face.';
    }
    return 'Camera aberta. Centralize o rosto; o sistema identificara o funcionario automaticamente.';
  }

  mensagemCapturaInvalida(detectorDisponivel: boolean) {
    return detectorDisponivel
      ? 'Centralize o rosto e pisque uma vez antes de confirmar.'
      : 'Nao foi possivel carregar o reconhecimento facial.';
  }

  capturaValida(rostoDetectado: boolean, provaVidaOk: boolean, descritorFacial: number[]) {
    return rostoDetectado && provaVidaOk && descritorFacial.length > 0;
  }

  aplicarFaceCadastro(funcionario: Funcionario, imagemFacialBase64: string, descritorFacial: number[]): Funcionario {
    return {
      ...funcionario,
      imagemFacialBase64,
      imagemFacialMimeType: 'image/jpeg',
      descritorFacial
    };
  }
}
